// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"z5-z","vrsnlCrossSiteLabel":"A5-z"};